import { Days } from 'components/Common/types'

export enum SortByOptions {
  startDate = 'START_DATE',
  endDate = 'END_DATE'
}

export enum SelectFilterVariant {
  type = 'TYPE',
  ruleType = 'RULE_TYPE',
  category = 'CATEGORY',
  status = 'STATUS'
}

export enum Type {
  cut_off_rule = 'CUT_OFF_RULE',
  special_availability = 'SPECIAL_AVAILABILITY'
}

export enum RuleType {
  recurring = 'RECURRING',
  special = 'SPECIAL_DAY'
}

export enum AssociatedModel {
  merchant = 'MERCHANT',
  store = 'STORE'
}

export enum Status {
  active = 'ACTIVE',
  draft = 'DRAFT',
  archived = 'ARCHIVED'
}

export { Days }

export type Pagination = {
  currentPage: number
  perPage: number
  totalItems: number
  totalPages: number
}

type CutoffDay = {
  id: string
  day: Days
  cutoffDays: number
  startTime: string
  endTime: string
  enabled: boolean
}

export type AvailabilityRule = {
  associatedWith: AssociatedModel
  categories: {
    id: string
    name: string
    archived_at: string | null
  }[]
  days: CutoffDay[]
  endDate: string
  id: string
  orderType: string
  ruleType: RuleType
  startDate: string
  status: Status
  stores: {
    id: string
    name: string
  }[]
  type: Type
}

export interface Store {
  id: string
  name: string
  slug: string
  archived_at: string | null
}

export interface Category {
  id: string
  name: string
  archived_at: string | null
}
